export const capacity: {
    id: string;
    label: string;
    value: number;
}[] = [
    {
        id: '1',
        label: '1',
        value: 1
    },
    {
        id: '2',
        label: '2',
        value: 2
    },
    {
        id: '3',
        label: '3',
        value: 3
    },
    {
        id: '4',
        label: '4',
        value: 4
    },
    {
        id: '5',
        label: '5',
        value: 5
    },
    {
        id: '6',
        label: '6',
        value: 6
    },
    {
        id: '7',
        label: '7',
        value: 7
    },
    {
        id: '8',
        label: '8',
        value: 8
    },
    {
        id: '9',
        label: '9',
        value: 9
    },
    {
        id: '10',
        label: '10',
        value: 10
    },
    {
        id: '11',
        label: '11',
        value: 11
    },
    {
        id: '12',
        label: '12',
        value: 12
    },
    {
        id: '13',
        label: '13',
        value: 13
    },
    {
        id: '14',
        label: '14',
        value: 14
    },
    {
        id: '15',
        label: '15',
        value: 15
    },
    {
        id: '16',
        label: '16',
        value: 16
    },
    {
        id: '17',
        label: '17',
        value: 17
    },
    {
        id: '18',
        label: '18',
        value: 18
    },
    {
        id: '19',
        label: '19',
        value: 19
    },
    {
        id: '20',
        label: '20',
        value: 20
    }
]